import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  font-family: Rubik;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-top: 21px;
  margin-bottom: 42px;
`;

export const Review = styled.div`
  width: 100;
  display: flex;
  margin-bottom: 42px;
`;

export const GeneralInformation = styled.div`
  width: 195px;
  display: block;
`;

export const ReviewInformation = styled.div`
  width: 100%;
  display: block;
`;

export const Label = styled.label`
  font-weight: normal;
  text-align: left;
  color: #2d3548;
  margin-bottom: 12px;
  display: block;
`;

export const LabelProvider = styled.label`
  font-weight: normal;
  text-align: left;
  color: #4da0ff;
  cursor: pointer;
`;

export const ReviewTitle = styled.div`
  font-weight: 500;
  text-align: left;
  color: #272727;
  margin-bottom: 12px;
`;

export const ReviewText = styled.div`
  font-weight: normal;
  text-align: left;
  color: #272727;
`;

export const StarsContainer = styled.div`
  width: auto;
  display: flex;
  justify-content: left;
  margin-bottom: 12px;
  margin-left: -6px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 100px 0px;
  width: 100%;
  font-family: Rubik;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #a5a5a5;
`;

export const Counter = styled.div`
  font-family: Rubik;
  font-weight: 500;
  text-align: left;
  color: #272727;
  margin-bottom: 12px;
  text-align: center;
`;